import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=70d870af&scoped=true&"
import script from "./LiveDetail.vue?vue&type=script&lang=ts&"
export * from "./LiveDetail.vue?vue&type=script&lang=ts&"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=70d870af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d870af",
  null
  
)

export default component.exports